











































import { Component, Prop, Vue, Watch, Inject } from 'vue-property-decorator';
import { User, UserHeadquarter } from '@/data/models/user.model';
import { CrudService } from '@/data/services/crud.service';
import { Search, SortDirection } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';
import { Headquarter } from '@/data/models/headquarter.model';
import store, { State } from '@/store';

@Component
export default class UtenteHeadquarters extends Vue {
	@Prop() utente!: User;
	@Prop({ default: false }) limit!: boolean;

	@Inject('CrudService') crudService!: CrudService<Headquarter>;
	@Inject('CrudService') userHeadquarterService!: CrudService<UserHeadquarter>;

	checked: Headquarter[] = [];
	userhqs: UserHeadquarter[] = [];

	rows: Headquarter[] = [];
	advancedSearch: Search = new Search('headquarter');
	loading: boolean = false;

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch.setSortField('id');
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
	}

	created() {
		this.loadHQs();
	}

	@Watch('utente', { immediate: true })
	onUserChange() {
		this.loadUserRoles();
	}

	loadUserRoles() {
		const search = new Search('userheadquarter');
		search.addSimpleFilter('uid', this.utente.id);
		this.userHeadquarterService
			.searchEntities(UserHeadquarter, 'userheadquarter', search, new Page(100))
			.then((result) => {
				this.userhqs = result;
				this.checked = this.userhqs.map((ur) => {
					const hq = new Headquarter();
					hq.id = ur.hid;
					return hq;
				});
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	loadHQs() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('active', 1);

		if (this.limit) {
			this.advancedSearch.addInFilter('id', this.state.headquarters.map(hq => hq.id));
		}

		const datareq = this.crudService.searchEntities(
			Headquarter,
			'headquarter',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Headquarter,
			'headquarter',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadHQs();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadHQs();
	}

	onCheck(rows: Headquarter[], row: Headquarter) {
		const index = rows.indexOf(row);
		if (index >= 0) {
			const model = new UserHeadquarter();
			model.uid = this.utente.id;
			model.hid = row.id;
			this.userHeadquarterService
				.createEntity(UserHeadquarter, 'userheadquarter', model)
				.then((result) => {
					this.userhqs.push(result);
				})
				.catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
					// reset change
					rows.splice(index, 1);
				});
		} else {
			const i = this.userhqs.map((ur) => ur.hid).indexOf(row.id);
			const model = this.userhqs[i];
			this.userHeadquarterService
				.deleteEntity(UserHeadquarter, 'userheadquarter', model)
				.then(() => {
					this.userhqs.splice(i, index);
				})
				.catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
					// reset change
					rows.push(row);
				});
		}
	}
}
